import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../constants';

@Injectable()
export class AccountClientSimplifiedService {

	private apiUrl = globalConst.baseAPI;  // URL para web api

	/**
	* Método construtor
	* @param http: Http
	*/
  constructor(private http: Http) { }
  
 

	getAccountClientDetails(token, idAccountClient) {
		return this.http
			.get(this.apiUrl + "accounts/v1/getcustomer/" + idAccountClient, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
  }
  
}


// WEBPACK FOOTER //
// ./src/app/account-client-simplified/service/account-client-simplified.service.ts